

import React, { Component } from 'react';
import "../css/SeleccionServicio.css"
import { FormGroup, Label, Col, Row, Card, CardBody, Button, Breadcrumb, BreadcrumbItem, Progress } from 'reactstrap';
import HeaderComp from "../components/HeaderComp"
import { OBTENER_URL_SERVICIO } from "../constants/action-types"
import fondo from "../imgs/KLBackground.png"
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { validarUsuario, actualizarLista } from "../actions/index";
import { Redirect } from 'react-router-dom';
import MensajeModal from "../components/MensajeModal"
import '../css/styleHome.css';
import axios from "axios"
import Timer from "react-time-counter";

//printer
//var printer = require("node-thermal-printer");
// eslint-disable-next-line

const mapStateToProps = state => {
    return {
        usuarioBase: state.usuarioBase,
        rol: state.rol,
        serviciosPadre: state.servicios,
        listaServicios: state.listaServicios,
        area: state.area,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        ...bindActionCreators({ validarUsuario, actualizarLista }, dispatch)
    };
};

class SeleccionServicio extends Component {

    constructor(props) {
        super(props);
        this.state = {
            modalEstado: false,
            modalTitulo: "",
            modalMensaje: "",
            modalFooter: "",
            validacion: false,
            breadPath: "",
            listaActual: "",
            navegacion: [],
            codServicioSelect: "",
            nomServicioSelect: "",
        };
        //printer
        /*
        this._printer = printer.init({
            type: 'sat',
            interface: '/dev/usb/lp0'
        });
        this.handleImpresion = this.handleImpresion.bind(this);
        */

        this.solicitarConfirmacion = this.solicitarConfirmacion.bind(this);
        this.toggle = this.toggle.bind(this);
        this.servicioConfirmado = this.servicioConfirmado.bind(this);
        this.buscarHijos = this.buscarHijos.bind(this)
        this.actualizarLista = this.actualizarLista.bind(this)
        this.breadButtonServicios = this.breadButtonServicios.bind(this)
        this.breadButtonPadres = this.breadButtonPadres.bind(this)
        this.cancelarSolicitud = this.cancelarSolicitud.bind(this)
        this.irAHome = this.irAHome.bind(this)
        this.validarSiHayAgente = this.validarSiHayAgente.bind(this)
    }


    //printer
    /*
    handleImpresion(TurnoAsignado) {
        this._printer.setTextNormal();
        this._printer.alignCenter();
        this._printer.println("Fundación Universitaria Konrad Lorenz.");
        this._printer.newLine();
        this._printer.println("Sistema de atención de usuarios.");
        this._printer.drawLine();
        this._printer.setTextDoubleHeight();
        this._printer.setTextDoubleWidth();
        this._printer.println("Su turno es: "+TurnoAsignado);
        this._printer.cut();
        this._printer.execute((err) => {
            if (err) {
                return console.log(err);
            }
            console.log('Done!');
        });
    }
*/

    solicitarConfirmacion(event) {
        this.setState({
            modalTitulo: "¿Deseas confirmar?",
            modalMensaje:
                <div>
                    <center>
                        <p>Deseas confirmar la solicitud de turno para el servicio:</p>
                        <p></p>
                        <p>{event.target.name}</p>
                    </center>
                </div>,
            modalFooter: <div>
                <Button color="danger" onClick={this.toggle}>Cancelar</Button>{' '}
                <Button id={event.target.id} name={event.target.name} onClick={this.validarSiHayAgente} color="success">Confirmar</Button>
            </div>,
        })
        this.toggle();
    }

    toggle() {
        this.setState({
            modalEstado: !this.state.modalEstado
        });
    }

    async validarSiHayAgente(event) {
        const idSolicitud = event.target.id;
        this.setState({
            codServicioSelect: event.target.id,
            nomServicioSelect: event.target.name,
            modalTitulo: "Espera por favor",
            modalMensaje:
                <div>
                    <center>
                        <p>¡Estamos buscando agentes para atenderte!</p>
                    </center>
                </div>,
            modalFooter: <div style={{ width: "100%" }}>
                <Progress animated color="success" value="100" />
            </div>
        })
        try {
            const response = await axios.get(OBTENER_URL_SERVICIO + "/agentesDisponibles/" + this.props.rol.rol + "/" + this.props.rol.codigo + "/" + idSolicitud + "/" + this.props.area.idArea);
            if (response.data.tipo === "EXITO") {
                this.servicioConfirmado();
            }
            else {
                this.setState({
                    modalTitulo: "Oops!",
                    modalMensaje:
                        <div>
                            <center>
                                <p>En el momento no tenemos agentes disponibles para atender tu solicitud</p>
                                <p>Por favor intenta de nuevo más tarde o si tienes otro trámite por resolver diferente al solicitado, por favor selecciónalo.</p>
                            </center>
                        </div>,
                    modalFooter: <div>
                        <Button color="danger" onClick={this.toggle}>Aceptar</Button>{' '}
                    </div>,
                })
            }
        } catch (error) {
            console.error(error);
        }
    }

    cancelarSolicitud() {
        this.setState({
            modalTitulo: "¿Deseas confirmar?",
            modalMensaje:
                <div>
                    <center>
                        <p>¿Estás seguro que deseas cancelar la solicitud del servicio?</p>
                    </center>
                </div>,
            modalFooter: <div>
                <Button onClick={this.toggle}>No</Button>{' '}
                <Button color="danger" onClick={this.irAHome} >Sí</Button>
            </div>,
        })
        this.toggle();
    }

    async servicioConfirmado() {
        var datosUsuarioBase = {
            identificacionUsuario: this.props.usuarioBase.identificacionUsuario,
            nombreUsuario: this.props.usuarioBase.nombreUsuario,
            genero: this.props.usuarioBase.genero,
            correo: this.props.usuarioBase.correo,
            telefono: this.props.usuarioBase.telefono, //null
            idServicio: this.state.codServicioSelect,
            nombreServicio: this.state.nomServicioSelect,
            area: this.props.area.idArea,
            rol: {
                rol: this.props.rol.rol,
                programa: this.props.rol.programa,
                codigo: this.props.rol.codigo,
                semestre: this.props.rol.semestre,
            }
        }
        try {
            const response = await axios.post(OBTENER_URL_SERVICIO + "/cola/" + this.props.area.idArea, datosUsuarioBase);
            if (response.data.tipo === "EXITO") {
                var res = response.data.mensaje.split(":*");
                var identifica = res[1];
                //printer
                //this.handleImpresion(identifica);

                this.setState({
                    modalTitulo: "Servicio confirmado.",
                    modalMensaje:
                        <div>
                            <center>
                                <h3>Por favor, retira el papel con el turno asignado.</h3>
                                <h3>Turno: </h3>
                                <h2>{identifica}</h2>
                            </center>
                        </div>,
                    modalFooter: <div style={{ width: "100%" }}>
                        <center>
                            <Label><Timer seconds={5} backward={true} id="timerTiempoModalX" label={<span></span>} /></Label>
                        </center>
                    </div>,
                })
                setTimeout(
                    function () {
                        this.irAHome();
                    }
                        .bind(this),
                    5000
                );
            }
            else {
                this.setState({
                    modalTitulo: "Oops!",
                    modalMensaje:
                        <div>
                            <center>
                                <p>En el momento no podemos agendar tu solicitud</p>
                                <p>Por favor intenta de nuevo más tarde o si tienes otro trámite por resolver diferente al solicitado, por favor selecciónalo.</p>
                            </center>
                        </div>,
                    modalFooter: <div>
                        <Button color="danger" onClick={this.toggle}>Aceptar</Button>{' '}
                    </div>,
                })
            }
        } catch (error) {
            console.error(error);
        }
    }


    irAHome() {
        this.setState({
            validacion: true
        })
    }

    componentWillMount() {
        if(this.props.serviciosPadre!== null){
            console.log(this.props.serviciosPadre)
        }
        
        this.setState({
            breadPath: <Breadcrumb>
                <BreadcrumbItem >{this.props.usuarioBase.identificacionUsuario}</BreadcrumbItem>
                <BreadcrumbItem active>{this.props.rol.rol}</BreadcrumbItem>
            </Breadcrumb>,
            listaActual: this.props.serviciosPadre.map(p => {
                if (p.esFinal === 1) {
                    return (
                        <Col xs="12" sm="12" md="6" lg="4" key={p.seqServicio} ><Button size="lg" onClick={this.solicitarConfirmacion} className="buttonAncho" id={p.seqServicio} name={p.namServicio} key={p.seqServicio} color="secondary">{p.namServicio}</Button></Col>
                        //<Col xs="12" sm="12" md="6" lg="4" key={p.seqServicio} ><Button size="lg" onClick={this.validarSiHayAgente} className="buttonAncho" id={p.seqServicio} name={p.namServicio} key={p.seqServicio} color="secondary">{p.namServicio}</Button></Col>

                    )
                }
                else {
                    return (
                        <Col xs="12" sm="12" md="6" lg="4" key={p.seqServicio} ><Button size="lg" onClick={this.buscarHijos} className="buttonAncho" id={p.seqServicio} name={p.namServicio} key={p.seqServicio} color="secondary">{p.namServicio}</Button></Col>
                    )
                }

            })
        })
    }

    buscarHijos(event) {
        var bread = this.state.navegacion.concat({ idBread: event.target.id, nombreBread: event.target.name })
        this.setState({ navegacion: bread })
        this.props.actualizarLista(this.props.rol.rol, this.props.rol.codigo, event.target.id, this.props.area.idArea);
    }


    componentWillReceiveProps(nextProps) {
        if (nextProps.listaServicios !== undefined) {
            if (nextProps.listaServicios !== this.props.listaServicios) {
                setTimeout(
                    function () {
                        this.actualizarLista();
                    }
                        .bind(this),
                    10
                );
            }
        }
    }

    breadButtonServicios(event) {
        var bandera = true;
        var nuevo = [];
        for (var j = 0; j < this.state.navegacion.length; j++) {
            if (bandera === true) {
                if (this.state.navegacion[j].idBread !== event.target.id) {
                    nuevo[j] =
                        {
                            idBread: this.state.navegacion[j].idBread,
                            nombreBread: this.state.navegacion[j].nombreBread
                        };
                } else {
                    nuevo[j] =
                        {
                            idBread: this.state.navegacion[j].idBread,
                            nombreBread: this.state.navegacion[j].nombreBread
                        };
                    bandera = false;
                }
            }
        }
        this.setState({
            navegacion: nuevo
        })
        this.props.actualizarLista(event.target.id);
    }

    breadButtonPadres() {
        this.setState({
            navegacion: [],
            breadPath: <Breadcrumb>
                <BreadcrumbItem >{this.props.usuarioBase.identificacionUsuario}</BreadcrumbItem>
                <BreadcrumbItem active>{this.props.rol.rol}</BreadcrumbItem>
            </Breadcrumb>,
            listaActual: this.props.serviciosPadre.map(p => {
                if (p.esFinal === 1) {
                    return (
                        <Col xs="12" sm="12" md="6" lg="4" key={p.seqServicio} ><Button size="lg" onClick={this.solicitarConfirmacion} className="buttonAncho" id={p.seqServicio} name={p.namServicio} key={p.seqServicio} color="secondary">{p.namServicio}</Button></Col>
                        //<Col xs="12" sm="12" md="6" lg="4" key={p.seqServicio} ><Button size="lg" onClick={this.validarSiHayAgente} className="buttonAncho" id={p.seqServicio} name={p.namServicio} key={p.seqServicio} color="secondary">{p.namServicio}</Button></Col>
                    )
                }
                else {
                    return (
                        <Col xs="12" sm="12" md="6" lg="4" key={p.seqServicio} ><Button size="lg" onClick={this.buscarHijos} className="buttonAncho" id={p.seqServicio} name={p.namServicio} key={p.seqServicio} color="secondary">{p.namServicio}</Button></Col>
                    )
                }

            })
        })
    }

    actualizarLista() {
        var nuevos = [];
        for (var j = 0; j < this.state.navegacion.length; j++) {
            if (j < this.state.navegacion.length - 1) {
                nuevos[j] = <BreadcrumbItem className="text-primary" key={this.state.navegacion[j].idBread} id={this.state.navegacion[j].idBread} onClick={this.breadButtonServicios}>{this.state.navegacion[j].nombreBread}</BreadcrumbItem>
            } else {
                nuevos[j] = <BreadcrumbItem className="text-muted" key={this.state.navegacion[j].idBread} active>{this.state.navegacion[j].nombreBread}</BreadcrumbItem>
            }
        }

        this.setState({
            breadPath:
                <Breadcrumb>
                    <BreadcrumbItem className="text-muted" key={this.props.usuarioBase.identificacionUsuario} >{this.props.usuarioBase.identificacionUsuario}</BreadcrumbItem>
                    <BreadcrumbItem key={this.props.rol.rol} onClick={this.breadButtonPadres} className="text-primary">{this.props.rol.rol}</BreadcrumbItem>
                    {nuevos}
                </Breadcrumb>,
            listaActual: this.props.listaServicios.map(p => {
                if (p.esFinal === 1) {
                    return (
                        <Col key={p.seqServicio} xs="12" sm="12" md="6" lg="4"><Button size="lg" onClick={this.solicitarConfirmacion} className="buttonAncho" id={p.seqServicio} name={p.namServicio} key={p.seqServicio} color="secondary" >{p.namServicio}</Button></Col>
                        //<Col key={p.seqServicio} xs="12" sm="12" md="6" lg="4"><Button size="lg" onClick={this.validarSiHayAgente} className="buttonAncho" id={p.seqServicio} name={p.namServicio} key={p.seqServicio} color="secondary">{p.namServicio}</Button></Col>
                    )
                }
                else {
                    return (
                        <Col key={p.seqServicio} xs="12" sm="12" md="6" lg="4"><Button size="lg" onClick={this.buscarHijos} className="buttonAncho" id={p.seqServicio} name={p.namServicio} key={p.seqServicio} color="secondary">{p.namServicio}</Button></Col>
                    )
                }
            })
        })
    }


    componentDidMount() {
        document.title = "DigiturnoKL - Selección de Servicio"
    }

    componentDidUpdate(prevState) {
        //console.log(prevState)
        //console.log(this.state)
        // Typical usage (don't forget to compare props):

    }

    render() {
        if (this.props.area.idArea === "" || this.props.area.idArea === undefined) {
            return <Redirect to={{ pathname: '/' }} />
        }
        if (this.state.validacion === true) {
            return <Redirect to={{ pathname: '/Usuario/Home' }} />
        }
        return (
            <div>
                <MensajeModal modal={this.state.modalEstado} titulo={this.state.modalTitulo} toggle={this.toggle} mensaje={this.state.modalMensaje} footer={this.state.modalFooter} ></MensajeModal>
                <div id="home">
                    <div className="bg-img" style={{ backgroundImage: "url(" + fondo + ")" }}>
                        <div className="overlay"></div>
                    </div>
                    <div className="home-wrapper">
                        <div className="container">
                            <Row>
                                <Col xs="12">
                                    <div className="home-content">

                                        <div className="box">

                                            <HeaderComp className="row header"></HeaderComp>

                                            <Row className="row content">
                                                <Col xs="3"></Col>
                                                <Col xs="6" >
                                                    <center>
                                                        <FormGroup>
                                                            <Label for="exampleEmail">Seleccione el servicio que desea: </Label>
                                                        </FormGroup>
                                                    </center>
                                                </Col>
                                                <Col xs="3"></Col>
                                            </Row>
                                            <Row className="row content">

                                                <Col xs="12">
                                                    <center>

                                                        <Card>
                                                            <CardBody>
                                                                <Row>
                                                                    {this.state.breadPath}
                                                                </Row>
                                                                <Row>

                                                                    <Col xs="12">
                                                                        <Row>
                                                                            {this.state.listaActual}
                                                                        </Row>
                                                                    </Col>

                                                                </Row>
                                                                <Row>
                                                                    <Col xs={{ size: 12 }}>
                                                                        <div className="clearfix" style={{ padding: '.5rem' }}>
                                                                            <button onClick={this.cancelarSolicitud} className="btn btn-danger float-right">Cancelar</button>
                                                                        </div>
                                                                    </Col>
                                                                </Row>
                                                            </CardBody>
                                                        </Card>
                                                    </center>
                                                </Col>

                                            </Row>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    </div>
                </div>
            </div>
        );
    }


}

export default connect(mapStateToProps, mapDispatchToProps)(SeleccionServicio);
